export const GoogleButton = () => {
  return (
    <button type="button" className="google-sign-in-button">
      Continue with Google
    </button>
  );
};
